import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import Navbar from '../navbar/Navbar';
import { useAuth } from '../../context/AuthContext';
import styles from './PrivateLayout.module.css';

export default function PrivateLayout() {
  const { authenticated } = useAuth();
  const location = useLocation();

  const hideNavbar = location.pathname === '/account';

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className={styles.layout}>
      {!hideNavbar && <Navbar />}
      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  );
}
